/**
 * # Transition subsystem
 *
 * This module contains APIs related to a Transition.
 *
 * See:
 * - [[TransitionService]]
 * - [[Transition]]
 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
 *
 * @preferred @publicapi @module transition
 */ /** */
export * from './interface';
export * from './hookBuilder';
export * from './hookRegistry';
export * from './rejectFactory';
export * from './transition';
export * from './transitionHook';
export * from './transitionEventType';
export * from './transitionService';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib-esm/transition/index.js
// module id = 556
// module chunks = 1